import { render, staticRenderFns } from "./AmendStudentInfo.vue?vue&type=template&id=32598b9c"
import script from "./AmendStudentInfo.vue?vue&type=script&lang=js"
export * from "./AmendStudentInfo.vue?vue&type=script&lang=js"
import style0 from "./AmendStudentInfo.vue?vue&type=style&index=0&id=32598b9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports